<template>
  <div>

<!--  Header Start Here   -->
    <header>
      <div class="container_large">
        <nav class="navbar navbar-expand-lg">
          <router-link class="navbar-brand" :to="{name: 'home'}"><img src="/src/assets/images/logo.png" class="img-fluid logo" alt=""></router-link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="toggler-icon"></span>
            <span class="toggler-icon"></span>
            <span class="toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto nav-admin">
              <li><router-link  :to="{name: 'home'}">Home</router-link></li>
              <li><a href="/#how-we-works">How It Works</a></li>
              <li><router-link :to="{name:'corporate-contracts'}">Commercial</router-link></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><router-link :to="{name:'faqs'}">FAQ</router-link></li>
            </ul>
          </div>
        </nav>
        <div class="top_right">
          <!-- Login Links -->
          <div class="login_links" v-if="!loginUser">
            <router-link :to="{name:'login'}">Login</router-link>
            <router-link :to="{name:'signup'}">Sign Up</router-link>
          </div>
          <!-- User Menu -->
           <div>
            <router-link :to="{name:redirect_name}" class="user_menu_route" v-if="loginUser"> 
              <div class="user_menu">
                  <div id="profileImage">{{intials}}</div>
                  <span id="fullName">{{full_name}}</span>
                  <i class="fas fa-cog fa-lg" style="margin-left:4px"></i>
              </div>
            </router-link>
           </div>
        </div>
      </div>
    </header>
    <!--  Header Ends Here   -->

  
  </div>
</template>
<script>
export default {
  data(){
    return{
      full_name: null,
      intials: null,
      redirect_name: null,
    }
  },
   watch: {
    $route() {
      $("#navbarSupportedContent").collapse("hide");
    },
  },
   computed:{
    loginUser(){
      if(this.$store.state.logedInUser){       
        if(this.$store.state.logedInUser && this.$store.state.logedInUser.full_name){
          const user = this.$store.state.logedInUser;
           if(user.is_admin=='1'){
            this.redirect_name = 'admin-dashboard';
          } else{
            this.redirect_name = 'account-profile';
          }
           this.full_name = this.$store.state.logedInUser.full_name;
            const intials = this.full_name.split(' ').map(name => name[0]).join('').toUpperCase();
            this.intials = intials;
          }   
        return this.$store.state.logedInUser;
      } else if(localStorage.getItem('current_user')){

        const user = JSON.parse(localStorage.getItem('current_user'));
        if(user.is_admin=='1'){
            this.redirect_name = 'admin-dashboard';
          } else{
            this.redirect_name = 'account-profile';
          }
       this.$store.dispatch("islogedIn", user);
           this.full_name = user.full_name;
            const intials = this.full_name.split(' ').map(name => name[0]).join('').toUpperCase();
            this.intials = intials;
             return user;

      } else if(!this.$store.state.logedInUser){
       return null;
       }
    }
  },
  async created(){
    
  }
}
</script>
<style scoped>
.user_menu_route{
    padding: 0;
    background: none;
    color: #3C3C3C !important;
    border-radius: 0;
}
.user_menu_route .user_menu #fullName{
    color: #3C3C3C !important;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/header.vue